import React, { createContext, useState, useContext, useEffect } from 'react';
import Auth from './Auth';
import { getCookie } from '../http/axios';
// import { useHistory } from 'react-router-dom';

// Create a context for authentication
const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    // const history = useHistory();


    useEffect(() => {
        if (token) {
            document.cookie = `${Auth.tokenKey}=${token}`;
        } else if (document.cookie.includes(`${Auth.tokenKey}`)){
            console.log("Token not set");
            setToken(getCookie())
        }
    }, [token]);

    
    return (
        <AuthContext.Provider value={{ token, setToken }}>
            {children}
        </AuthContext.Provider>
    );
};

// Custom hook to use the AuthContext
export const useAuth = () => {
    return useContext(AuthContext);
};


